import component from './contentInsights.vue'

export default component
